
import Phaser from 'phaser';
import EDC from '@/components/games/shared/globals';
import router from '@/router';
import store from '@/store';
import CursorManager from '@/components/games/shared/cursor-manager';

/**
 *
 */
EDC.Games.NextGamePicker.Scenes.Main = function () {};

const nextGamePicker = EDC.Games.NextGamePicker.Scenes.Main.prototype;

nextGamePicker.init = function () {
  this.bg = null;
  this.content = null;
  this.cursorManager = null;
  this.logo = null;
  this.scale.off('resize', this.resize, this);
};

nextGamePicker.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);

  this.bg = this.add.image(this.scale.width / 2, this.scale.height / 2, 'background');
  this.content = this.add.container();

  const titleFrame = this.add.image(0, 200, 'title-frame').setOrigin(0);
  titleFrame.displayWidth *= 1.15;
  titleFrame.displayHeight *= 1.05;
  this.logo = this.add.image(0, 0, 'logo');
  this.logo.init_scale = 1;
  const title = this.add.image(titleFrame.displayWidth / 2, titleFrame.y + titleFrame.displayHeight / 2, 'start-title');

  const rpgFrame = this.add.image(245, 0, 'frame');
  const rpgFrameHover = this.add.image(245, 0, 'frame-hover');
  rpgFrameHover.setAlpha(0);
  const rpgIcon = this.add.image(245, 0, 'rpg-icon');
  const rpgLabel = this.add.image(-130, -10, 'rpg-label').setVisible(false);

  const autoFrame = this.add.image(-245, 0, 'frame');
  const autoFrameHover = this.add.image(-245, 0, 'frame-hover');
  autoFrameHover.setAlpha(0);
  const autoIcon = this.add.image(-245, 0, 'auto-icon');
  const autoLabel = this.add.image(180, -10, 'auto-label').setVisible(false);

  const pickFrame = this.add.image(-245, 0, 'frame');
  const pickFrameHover = this.add.image(-245, 0, 'frame-hover');
  pickFrameHover.setAlpha(0);
  const pickIcon = this.add.image(-245, 0, 'pick-icon');
  const pickLabel = this.add.image(150, -10, 'pick-label').setVisible(false);

  const repeatFrame = this.add.image(245, 0, 'frame');
  const repeatFrameHover = this.add.image(245, 0, 'frame-hover');
  repeatFrameHover.setAlpha(0);
  const repeatIcon = this.add.image(245, 0, 'repeat-icon');
  const repeatLabel = this.add.image(-240, -10, 'repeat-label').setVisible(false);

  const rpgContainer = this.add.container(0, 600, [rpgLabel, rpgFrame, rpgFrameHover, rpgIcon]);
  rpgContainer.setSize(960, 510);

  const autoContainer = this.add.container(0, 1000,
    [autoFrame, autoFrameHover, autoIcon, autoLabel]);
  autoContainer.setSize(960, 510);

  const pickContainer = this.add.container(0, rpgContainer.y,
    [pickFrame, pickFrameHover, pickIcon, pickLabel]);
  pickContainer.setSize(960, 510);

  const repeatContainer = this.add.container(0, autoContainer.y, [
    repeatFrame,
    repeatFrameHover,
    repeatIcon,
    repeatLabel,
  ]);
  repeatContainer.setSize(960, 510);

  this.cursorManager.setDefaultDraggableEvents(rpgContainer);
  this.cursorManager.setDefaultDraggableEvents(autoContainer);
  this.cursorManager.setDefaultDraggableEvents(pickContainer);
  this.cursorManager.setDefaultDraggableEvents(repeatContainer);

  this.content.add([
    titleFrame,
    title,
    rpgContainer,
    autoContainer,
    pickContainer,
    repeatContainer]);

  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });

  rpgContainer.x = -800;
  repeatContainer.x = rpgContainer.x;
  autoContainer.x = 1200 + 1000;
  pickContainer.x = autoContainer.x;
  this.showTitle([titleFrame, title, this.logo]);
  this.showGameTypeTile(rpgContainer, rpgLabel, { x: rpgContainer.x + 1000, y: rpgContainer.y });
  this.showGameTypeTile(autoContainer,
    autoLabel,
    { x: autoContainer.x - 1000, y: autoContainer.y });
  this.showGameTypeTile(pickContainer, pickLabel, { x: pickContainer.x - 1000, y: rpgContainer.y });
  this.showGameTypeTile(repeatContainer,
    repeatLabel,
    { x: repeatContainer.x + 1000, y: autoContainer.y });

  const rpgHitArea = new Phaser.Geom.Rectangle(0, 0, 960, 490);
  rpgContainer.setInteractive(rpgHitArea, Phaser.Geom.Rectangle.Contains);
  autoContainer.setInteractive(rpgHitArea, Phaser.Geom.Rectangle.Contains);
  pickContainer.setInteractive(rpgHitArea, Phaser.Geom.Rectangle.Contains);
  repeatContainer.setInteractive(rpgHitArea, Phaser.Geom.Rectangle.Contains);

  rpgContainer.on('pointerover', () => {
    rpgFrameHover.setAlpha(1);
  });
  rpgContainer.on('pointerout', () => {
    rpgFrameHover.setAlpha(0);
  });
  autoContainer.on('pointerover', () => {
    autoFrameHover.setAlpha(1);
  });
  autoContainer.on('pointerout', () => {
    autoFrameHover.setAlpha(0);
  });
  pickContainer.on('pointerover', () => {
    pickFrameHover.setAlpha(1);
  });
  pickContainer.on('pointerout', () => {
    pickFrameHover.setAlpha(0);
  });
  repeatContainer.on('pointerover', () => {
    repeatFrameHover.setAlpha(1);
  });
  repeatContainer.on('pointerout', () => {
    repeatFrameHover.setAlpha(0);
  });

  rpgContainer.on('pointerdown', this.onRPGclick);
  autoContainer.on('pointerdown', this.onAutoClick);
  pickContainer.on('pointerdown', this.onPickClick);
  repeatContainer.on('pointerdown', this.onRepeatClick);
};

nextGamePicker.showTitle = function (array) {
  array.map((target) => {
    target.y -= 300;
    return true;
  });
  this.tweens.add({
    targets: array,
    duration: 900,
    y(target) {
      return target.y + 300;
    },
    ease: 'Bounce.easeOut',
  });
};

nextGamePicker.showGameTypeTile = function (target, label, { x, y }) {
  this.tweens.add({
    targets: target,
    duration: 500,
    x,
    y,
    onComplete: () => {
      label.setVisible(true);
      this.makeGameTypeLabelExpand(label);
    },
  });
};

nextGamePicker.makeGameTypeLabelExpand = function (label) {
  this.tweens.add({
    targets: label,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 1000,
    yoyo: true,
    repeat: -1,
  });
};

nextGamePicker.onRPGclick = function () {
  router.push({ name: 'rpg' });
};

nextGamePicker.onAutoClick = function () {
  store.dispatch('gameConfig/runALI');
};

nextGamePicker.onPickClick = function () {
  router.push({ name: 'games' });
};

nextGamePicker.onRepeatClick = function () {
  const prevGameId = localStorage.getItem('prevGameId');
  router.push({ name: 'game', params: { id: prevGameId } });
};

nextGamePicker.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;
  this.cameras.resize(width, height);
  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);
  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.9) / contentWidth;
  const scaleY = (height * 0.85) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition(
    (width - bounds.width) / 2 + 220 * neededScale,
    height / 2 - bounds.height + 280 * neededScale,
  );

  this.logo.setScale(this.logo.init_scale * neededScale);
  this.logo.setPosition(this.content.x + bounds.width / 2 - 1050 * neededScale,
    this.content.y + 300 * neededScale);
};

export default EDC.Games.NextGamePicker.Scenes.Main;
